import React from "react";
import {
	TextField,
	Select,
	MenuItem,
	makeStyles,
	FormControl,
	InputLabel,
	Checkbox,
} from '@material-ui/core';
import { useStoreState } from 'easy-peasy';

const useStyles = makeStyles((theme) => ({
	marginRight: {
		marginRight: '10px',
	},
	marginLeft: {
		marginLeft: '20px',
	},
	formControl: {
		margin: theme.spacing(0),
		width: '100%',
	},
}));
import {
	KeyboardDatePicker
} from '@material-ui/pickers';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ChipInput from 'material-ui-chip-input';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
import { globalDateEntity, DatepickerStartDate } from '../../constants/applicationConstants';
import { stringConstants } from '../../constants/stringConstants';

const RenderField = ({
	field, // { name, value, onChange, onBlur }
	form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
	values,
	...props
}) => {
	
	const reportState = useStoreState((state) => state.report);
	const sourceList = reportState.sourceList; 
	const classes = useStyles();
	let isClientOrBL = form?.values?.data_type;
	// ALL OPTION LOGIC
	const [checkAll, setCheckAll] = React.useState(false);
	const filter = createFilterOptions();
	const getOptionLabel = option => `${option.title}`;
	const optionRenderer = (option, { selected }) => {
		const selectAllProps =
			option.value === "select-all" // To control the state of 'select-all' checkbox
				? { checked: checkAll }
				: {};
		return (
			<>
				<Checkbox
					color="primary"
					icon={icon}
					checkedIcon={checkedIcon}
					style={{ marginRight: 8 }}
					checked={selected}
					{...selectAllProps}
				/>
				{getOptionLabel(option)}
			</>
		);
	};
	// ALL OPTION LOGIC
	if (isClientOrBL === 'clients' || isClientOrBL === 'businesslines') {
		isClientOrBL = false;
	} else {
		isClientOrBL = true;
	}
	if (props.type == "number" && props.range == 'true') {
		return (<TextField type="number" variant="outlined" margin="normal" label="Value 2" placeholder="Value" className={classes.marginRight} {...field} {...props} />);
	}
	if (props.type == "date" && props.range == 'true') {
		return (<KeyboardDatePicker
			margin="normal"
			variant="inline"
			inputVariant="outlined"
			label="To Date"
			format={globalDateEntity.datePickerFormat}
			autoOk
			required={isClientOrBL}
			value={field.value || null}
			name={field.name}
			className={classes.marginRight}
			onChange={value => { form.setFieldValue(field.name, value ? value : '', true); }}
			minDate={new Date(DatepickerStartDate)}
			minDateMessage={stringConstants.minDate}
		/>);
	}

	if (props.type == "text") {
		return <TextField type="text" variant="outlined" label="Value" placeholder="Value" margin="normal" {...field} {...props} />
	}

	if (props.type == "number") {
		return <TextField type="number" variant="outlined" label="Value" placeholder="Value" margin="normal" {...field} {...props} />
	}

	if (props.type == "boolean") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={"label" + props.id}>Yes/No</InputLabel>
			<Select name={props.name} labelId={"label" + props.id} {...field} {...props} label="Yes/No">
				<MenuItem value=""><em>None</em></MenuItem>
				<MenuItem value="y">Yes</MenuItem>
				<MenuItem value="n">No</MenuItem>
			</Select>
		</FormControl>);
	}
	if (props.type == "pa_status") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={"label" + props.id}>Yes/No</InputLabel>
			<Select name={props.name} labelId={"label" + props.id} {...field} {...props} label="Yes/No">
				<MenuItem value=""><em>None</em></MenuItem>
				<MenuItem value="y">Yes</MenuItem>
				<MenuItem value="n">No</MenuItem>
				<MenuItem value="u">Undetermined</MenuItem>
			</Select>
		</FormControl>);
	}
	if (props.type == "enum-status") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={"label" + props.id}>Status</InputLabel>
			<Select name={props.name} labelId={"label" + props.id} {...field} {...props} label="Status">
				<MenuItem value=""><em>None</em></MenuItem>
				<MenuItem value="approved">Approved</MenuItem>
				<MenuItem value="draft">Draft</MenuItem>
			</Select>
		</FormControl>);
	}
	if (props.type == "procedure-enum-status") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={"label" + props.id}>Status</InputLabel>
			<Select name={props.name} labelId={"label" + props.id} {...field} {...props} label="Status">
				<MenuItem value=""><em>None</em></MenuItem>
				<MenuItem value="active">Active</MenuItem>
				<MenuItem value="inactive">Inactive</MenuItem>
			</Select>
		</FormControl>);
	}
	if (props.type == "prior_auth_exumption") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={"label" + props.id}>PA Handling</InputLabel>
			<Select name={props.name} labelId={"label" + props.id} {...field} {...props} label="PA Handling">
				<MenuItem value="exempt">Exempt</MenuItem>
				<MenuItem value="non-exempt">Non-Exempt</MenuItem>
				<MenuItem value="carve-out-to-vendor">
					Carve-Out to Vendor
				</MenuItem>
			</Select>
		</FormControl>);
	}
	if (props.type == "user_type") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={"label" + props.id}>User Type</InputLabel>
			<Select name={props.name} labelId={"label" + props.id} {...field} {...props} label="User Type">
				<MenuItem value="provider">Provider</MenuItem>
				<MenuItem value="member">Member</MenuItem>
			</Select>
		</FormControl>);
	}
	if (props.type === "transaction_source") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={"label" + props.id}>Source</InputLabel>
			<Select name={props.name} labelId={"label" + props.id} {...field} {...props} label="Source">
				<MenuItem value="">
					<em>None</em>
				</MenuItem>
				{sourceList.map((val, idx) => {
					return (<MenuItem key={val.PK} value={val.PK}>{val.title}</MenuItem>)
				})}

			</Select>
		</FormControl>);
	}
	if (props.type == "date") {
		return (<KeyboardDatePicker
			margin="normal"
			variant="inline"
			inputVariant="outlined"
			label={props.title}
			format={globalDateEntity.datePickerFormat}
			autoOk
			required={isClientOrBL}
			name={field.name}
			value={field.value || null}
			onChange={value => form.setFieldValue(field.name, value ? value : '', true)}
			minDate={new Date(DatepickerStartDate)}
			minDateMessage={stringConstants.minDate}
		/>)
	}
	if (props.type == "custom-type") {
		return (<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id={`label-${field.name}`}>{props.title}</InputLabel>
			<Select
				labelId={`label-${field.name}`}
				placeholder={props.title}
				name={field.name}
				value={field.value}
				onChange={value => { form.setFieldValue(field.name, value, true); }}
				label={props.title}
				{...field} {...props}
			>
				<MenuItem value=""><em>None</em></MenuItem>
				{props.data.map((value, index) => {
					return (<MenuItem key={index} value={value.SK}>{value.title}</MenuItem>);
				})}
			</Select>
		</FormControl>
		);
	}
	if (props.type == "multi-select") {
		return (
			<FormControl variant="outlined" className={classes.formControl}>
				<Autocomplete className={classes.autoComp} multiple name={field.name}
					options={
						props.data && props.data.length > 0
							? props.data
							: []
					}
					value={(field && field.value) ? field.value : []}
					disableCloseOnSelect
					getOptionLabel={(option) => option.title}
					onChange={(e, value) => { form.setFieldValue(field.name, value); }}
					getOptionSelected={(option, value) => option.PK === value.PK}
					renderOption={(option, { selected }) => (
						<>
							<Checkbox
								icon={icon}
								checkedIcon={checkedIcon}
								color="primary"
								style={{ marginRight: 8 }}
								checked={selected}
							/>
							{option.title}
						</>
					)}
					renderInput={(params) => (<TextField required {...params} variant="outlined" label={props.title} />)}
				/>
			</FormControl>);
	}
	if (props.type == "multi-select-with-all-option") {
		return (
			<FormControl variant="outlined" className={classes.formControl}>
				<Autocomplete className={classes.autoComp} multiple name={field.name}
					limitTags={4}
					options={
						props.data && props.data.length > 0
							? props.data
							: []
					}
					value={(field && field.value) ? field.value : []}
					disableCloseOnSelect
					getOptionLabel={(option) => option.title}
					filterOptions={(options, params) => {
						const filtered = filter(options, params);
						return [{ title: "Select all", value: "select-all" }, ...filtered];
					}}
					onChange={(e, value, reason) => {
						if (reason === "select-option" || reason === "remove-option") {
							if (value && value.find(option => option.value === "select-all")) {
								setCheckAll(!checkAll);
								let result = [];
								result = props?.data.filter(el => el.value !== "select-all");
								form.setFieldValue(field.name, checkAll ? [] : result);
							} else {
								setCheckAll(false);
								form.setFieldValue(field.name, value);
							}
						} else if (reason === "clear") {
							setCheckAll(false);
							return form.setFieldValue(field.name, []);
						}
					}}
					getOptionSelected={(option, value) => option.PK === value.PK}
					renderOption={optionRenderer}
					renderInput={(params) => (<TextField required {...params} variant="outlined" label={props.title} />)}
				/>
			</FormControl>);
	}
	if (props.type == "tags") {
		return (<FormControl variant="outlined" className={classes.formControl}><ChipInput
			name={field.name}
			style={{ width: '100%', marginTop: '1s6px', marginBottom: '16px' }}
			className={`${classes.chipInputWrapper} `}
			label={props.title}
			variant="outlined"
			value={props.data}
			onAdd={(chip) => props.handleAddChip(chip)}
			onDelete={(chip) => props.handleDeleteChip(chip)}
			placeholder={'Type code and hit enter '} /></FormControl>)
	}


};
export default RenderField;
